import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCopyOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M22.333 29.333a1 1 0 0 0 1-1v-5h5a1 1 0 0 0 1-1V3.667a1 1 0 0 0-1-1H9.667a1 1 0 0 0-1 1v5h-5a1 1 0 0 0-1 1v18.666a1 1 0 0 0 1 1zM10.667 4.667h16.666v16.666H10.667zm-6 6h4v11.666a1 1 0 0 0 1 1h11.666v4H4.667z" clipRule="evenodd" /></svg>;
export default SvgIconCopyOutlined;